import _ from 'lodash'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import Summary from '../components/molecules/Summary'
import tracking from '../actions/tracking'

class SummaryWrapper extends PureComponent {
  render () {
    if (!this.props.initialProps) return null
    return (
      <div>
        <Summary {...this.props} />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    adults: state.summary.adults,
    checkinDate: state.summary.checkinDate,
    checkoutDate: state.summary.checkoutDate,
    children: state.summary.children,
    infants: state.summary.infants,
    initialProps: state.summary.initialProps,
    labelHotelDate: _.get(state.summary.brandConfig, 'UITextDefaults.labelNight'),
    labelNights: _.get(state.summary.brandConfig, 'UITextDefaults.labelNights'),
    labelParkDate: _.get(state.summary.brandConfig, 'UITextDefaults.labelParkDate'),
    labelPartyComp: _.get(state.summary.brandConfig, 'UITextDefaults.labelPartyComp'),
    labelRooms: _.get(state.summary.brandConfig, 'UITextDefaults.labelRooms'),
    labelSubmit: _.get(state.summary.brandConfig, 'UITextDefaults.labelSubmit'),
    labelTickets: _.get(state.summary.brandConfig, 'UITextDefaults.labelTickets'),
    parkDate: state.summary.parkDate,
    roomDescriptions: state.summary.roomDescriptions,
    ticketDescriptions: state.summary.ticketDescriptions,
    title: state.summary.title
  }
}

function mapDispatchToProps (dispatch) {
  return {
    trackValues: (action, label) => {
      return dispatch(tracking.track(
        action,
        'summary',
        label
      ))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryWrapper)
